import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhCN from './locales/zh-CN.js';
import zhTW from './locales/zh-TW.js';
import en from './locales/en-US.js';
import es from './locales/es-ES.js';
import esMX from './locales/es-MX.js';
import ar from './locales/ar-SA.js';

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: 'zh-CN',
		supportedLngs: ['zh-CN', 'zh-TW', 'en-US', 'es-ES', 'es-MX', 'ar-SA'],
		resources: {
			'zh-CN': { translation: zhCN },
			'zh-TW': { translation: zhTW },
			'en-US': { translation: en },
			'es-ES': { translation: es },
			'es-MX': { translation: esMX },
			'ar-SA': { translation: ar },
		},
		interpolation: { escapeValue: false },
		detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
	});

export default i18n;
